import { environment } from '../../../environments/environment';

/**
 * Shape of the Firebase Web SDK config object.
 * Values are supplied per-environment via environment.ts / environment.prod.ts.
 *
 * Obtain these from Firebase Console:
 * Project Settings → General → Your apps → SDK setup and configuration (Web).
 */
export interface FirebaseAppConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  /**
   * Web Push VAPID key (FCM Step 2).
   * Firebase Console → Project Settings → Cloud Messaging → Web Push certificates.
   */
  vapidKey: string;
  /** Optional; required only if Google Analytics is enabled for the project. */
  measurementId?: string;
}

/**
 * Returns the active environment's Firebase configuration.
 * Keeps credentials out of services and components.
 */
export function getFirebaseConfig(): FirebaseAppConfig {
  return environment.firebase;
}
